import styled, { css } from "styled-components";

export const StyledCta = styled.div`
  display: inline-block;
`;
